import styled, { css } from 'styled-components';

export const Favorite = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    cursor: pointer;

    &:hover{
      svg {
        path {
          stroke: ${theme.v2.colors.feedback.attentionMedium};
        }
      }
    }
  `}
`;
